import type { DagDashboardListParams } from '@/entities/dag';

export const dagKeys = {
  all: ['dag'] as const,
  dashboardList: (params?: DagDashboardListParams) =>
    [
      ...dagKeys.all,
      'dashboardList',
      params?.keyword?.trim() ?? '',
      params?.offset ?? null,
      params?.limit ?? null,
      params?.status?.trim() ?? '',
      params?.tag?.trim() ?? '',
      params?.maturity?.trim() ?? '',
      params?.isBookmarked ?? null,
      params?.sortBy ?? '',
      params?.sortOrder ?? '',
    ] as const,
  dagList: (params?: { dagDisplayNamePattern?: string }) =>
    [...dagKeys.all, 'dagList', params?.dagDisplayNamePattern ?? ''] as const,
  dagDashboardDetail: (dagUuid: string) => [...dagKeys.all, 'dagDashboardDetail', dagUuid] as const,
  dagOverview: (dagUuid: string) => [...dagKeys.all, 'dagOverview', dagUuid] as const,
  dagTaskList: (dagUuid: string) => [...dagKeys.all, 'dagTaskList', dagUuid] as const,
  dagTaskGraph: (dagUuid: string) => [...dagKeys.all, 'dagTaskGraph', dagUuid] as const,
  dagVersionList: (dagUuid: string) => [...dagKeys.all, 'dagVersionList', dagUuid] as const,
  dagImmutableCode: () => [...dagKeys.all, 'dagImmutableCode'] as const,
  globalLibraries: () => [...dagKeys.all, 'globalLibraries'] as const,
  dagTemplateCode: (dagUuid: string) => [...dagKeys.all, 'dagTemplateCode', dagUuid.trim()] as const,
  dagVersionCode: (params: { dagUuid: string; version: number }) =>
    [...dagKeys.all, 'dagVersionCode', params.dagUuid.trim(), params.version] as const,
  dagExecutionList: (params: { dagUuid: string; limit?: number; offset?: number }) =>
    [...dagKeys.all, 'dagExecutionList', params.dagUuid.trim(), params.limit ?? null, params.offset ?? 0] as const,
  dagExecutionChart: (params: { dagUuid: string; limit?: number; offset?: number }) =>
    [...dagKeys.all, 'dagExecutionChart', params.dagUuid.trim(), params.limit ?? null, params.offset ?? 0] as const,
  dagTaskLog: (params: { dagUuid: string; dagRunId: string; taskId?: string; tryNumber?: number }) =>
    [
      ...dagKeys.all,
      'dagTaskLog',
      params.dagUuid.trim(),
      params.dagRunId.trim(),
      params.taskId?.trim() ?? '',
      params.tryNumber ?? null,
    ] as const,
  dagDetail: (dagId: string) => [...dagKeys.all, 'dagDetail', dagId] as const,
  dagCodeVersions: (dagId: string) => [...dagKeys.all, 'dagCodeVersions', dagId] as const,
  dagRunList: (params: { dagId: string; limit?: number; offset?: number; orderBy?: string[] }) =>
    [
      ...dagKeys.all,
      'dagRunList',
      params.dagId,
      params.limit ?? null,
      params.offset ?? 0,
      ...(params.orderBy ?? ['-run_after']),
    ] as const,
  dagTasks: (dagId: string) => [...dagKeys.all, 'dagTasks', dagId] as const,
  taskInstances: (params: { dagId: string; taskId: string }) =>
    [...dagKeys.all, 'taskInstances', params.dagId, params.taskId] as const,
  latestTaskInstance: (params: { dagId: string; taskId: string }) =>
    [...dagKeys.all, 'latestTaskInstance', params.dagId, params.taskId] as const,
  dagStructure: (dagId: string) => [...dagKeys.all, 'dagStructure', dagId] as const,
  dagRuns: (dagId: string) => [...dagKeys.all, 'dagRuns', dagId] as const,
  dagGridRuns: (params: { dagId: string; limit?: number }) =>
    [...dagKeys.all, 'dagGridRuns', params.dagId, params.limit ?? null] as const,
  dagTaskInstanceSummary: (params: { dagId: string; runId: string }) =>
    [...dagKeys.all, 'dagTaskInstanceSummary', params.dagId, params.runId] as const,
  importErrors: () => [...dagKeys.all, 'importErrors'] as const,
} as const;
